import { useSelector } from 'react-redux'
import Accordion from '../../../../../UI/Accordion/Accordion'
import UnitCalculation from './UnitCalculation'
import props from '../../../../../../redux/props'
import { Concept, ConceptDataCluster, ConceptValues } from '../../../../../../types/Survey/Analysis/Concept'
import Headline from '../../../../../UI/Headline/Headline'
import { formatNumber, sortConceptValues } from '../../../../../../utility'

type Props = {
  conceptDataCluster: ConceptDataCluster
  concept: Concept
  update?: (unitUUID: string) => (values: ConceptValues) => void
}

const OrganizationUnit: React.FC<Props> = ({ conceptDataCluster, concept, update }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const getUnitValues = (unitUUID: string) => {
    const unitValues = concept.units[unitUUID]
    return unitValues
  }

  const items = Object.keys(concept.units)
    .filter((u) => u !== 'sum')
    .map((key) => concept.units[key])
    .sort(sortConceptValues)
    .map((conceptUnit, i) => {
      return {
        key: conceptUnit.unitUUID,
        title: `${conceptUnit.name} (${formatNumber(conceptUnit.ergebnisse.total)} ${t.generic.squareMeterSuffix})`,
        content: (
          <UnitCalculation
            conceptDataCluster={conceptDataCluster}
            values={getUnitValues(conceptUnit.unitUUID)}
            concept={concept}
            updateValues={!!update ? update(conceptUnit.unitUUID) : null}
            index={i}
          />
        ),
      }
    })

  return (
    <div>
      <Headline text={t.survey.analysis.concept.unit.headline} />
      {Object.keys(items).length <= 0 && <div>{t.survey.analysis.calculation.noDataAvailable}</div>}
      {Object.keys(items).length > 0 && <Accordion className="mt-3" items={items} />}
    </div>
  )
}

export default OrganizationUnit
